import * as React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import { Provider } from "react-redux";
import { PersistGate as PersistGateBase } from "redux-persist/integration/react";
const PersistGate = PersistGateBase as unknown as React.ComponentType<any>;
import Home from "./routes/home";
import Checkout from "./routes/checkout";
import CheckoutComplete from "./routes/checkoutcomplete";
import CheckoutEmpty from "./routes/checkoutempty";
import Program from "./routes/program";
import ProgramClass from "./routes/programclass";
import ProviderRoute from "./routes/provider";
import Receipt from "./routes/receipt";
import NotFound from "./routes/notfound";
import TestAuth from "./routes/testauth";
import { createStore } from "./store/index";

// Render the app   
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
const { store, persistor } = createStore();

root.render(
    <StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter basename="register">
                    <Routes>
                        <Route index element={<Home />} />
                        <Route path="provider">
                            <Route path=":providerid" element={<ProviderRoute />} />
                        </Route>
                        <Route path="program">
                            <Route path=":programid" element={<Program />} />
                        </Route>
                        <Route path="programclass">
                            <Route
                                path=":programclassid"
                                element={<ProgramClass />}
                            />
                        </Route>
                        <Route path="receipt">
                            <Route path=":receiptid" element={<Receipt />} />
                        </Route>
                        <Route path="checkout">
                            <Route path=":providerid" element={<Checkout />} />
                        </Route>
                        <Route path="checkoutcomplete">
                            <Route path=":providerid" element={<CheckoutComplete />} />
                        </Route>
                        <Route path="checkoutempty">
                            <Route path=":providerid" element={<CheckoutEmpty />} />
                        </Route>
                        <Route path="testauth" element={<TestAuth />} />
                        {/* 404 Catch-All Route */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </StrictMode>,
);
